<template>
  <div>
    <!-- <h1>This is view Package Package {{ packname }}</h1> -->
    <b-card
      header="Client"
      header-tag="header"
      :title="orgName"
      header-text-variant="white"
      :border-variant="getColour()"
      :header-bg-variant="getColour()"
      align="left"
      class="mt-3"
      :footer-html="getFooter()"
    >
      <b-card-text>Client details as follows</b-card-text>
      <b-list-group flush>
        <b-list-group-item
          ><strong
            ><em><u>Organisation </u></em></strong
          ></b-list-group-item
        >
        <b-list-group-item
          ><strong>E-mail: </strong>{{ orgEmail }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Telephone: </strong>{{ orgTel | landtel }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Address: </strong>{{ shortAddress }}</b-list-group-item
        >
        <b-list-group-item
          ><strong
            ><em><u>Contact Person </u></em></strong
          ></b-list-group-item
        >
        <b-list-group-item
          ><strong>Name: </strong>{{ readyName }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Job Role: </strong>{{ perJob }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>E-mail: </strong>{{ perEmail }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Telephone: </strong>{{ perTel | landtel }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Mobile: </strong>{{ PerMob | mobileno }}</b-list-group-item
        >
        <b-list-group-item
          ><strong>Added On: </strong
          >{{ orgAdded | justdate }}</b-list-group-item
        >
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "ClientCard",
  props: {
    orgName: String,
    state: Number,
    endday: String,

    orgEmail: String,
    orgTel: String,
    // orgAddress: String,

    orgAddLn1: String,
    orgAddLn2: String,
    orgAddStreet: String,
    orgAddCity: String,
    orgAddCounty: String,
    orgAddPC: String,

    // perName: String,
    perTitle: String,
    perFname: String,
    perLname: String,

    perJob: String,
    perEmail: String,
    perTel: String,
    PerMob: String,
    orgAdded: String
  },
  data() {
    return {
      EndDay: this.endday
    };
  },
  methods: {
    getAddTxt(txt) {
      if (!txt) return "";
      return txt + ", ";
    },
    getColour() {
      return parseInt(this.state) == 1 ? "info" : "danger";
    },
    getFooter() {
      return parseInt(this.state) == 1
        ? "<a href='deleteClient()' class='card-link'>Manage Client</a>"
        : "<strong>Removed On: " + this.EndDay + "</strong>";
    }
    /*,
     deleteClient() {
      this.$confirm({
        title: "Delete Package",
        text: "Are you sure you want to DELETE this package?",
        type: "warning"
        //timer: 6000
      }).then(r => {
        console.log(r.value);
      });
    }*/
  },
  computed: {
    shortAddress: function() {
      return (
        this.getAddTxt(this.orgAddStreet) +
        this.getAddTxt(this.orgAddCity) +
        this.getAddTxt(this.orgAddCounty) +
        this.orgAddPC
      );
    },
    readyName: function() {
      return this.perTitle + ". " + this.perFname + " " + this.perLname;
    }
  }
};
</script>
